export default __webpack_public_path__ + "static/quote-video-5-static-530a229f53ea6f4e2b5bf8fa8a4dd661.png";